import * as React from 'react';
import CardButton from "./CardButton";
import styled from 'styled-components';
import cardImg from '../../assets/img/homeAffiliations.png';
import spiceImg from '../../assets/img/affSpice.png';
import ropeImg from '../../assets/img/ropeHome.png';
import {BodyContainer} from "../Container/Container";
import Slider from 'react-slick';
import nextArrow from '../../assets/img/nextArrow.jpg';
import previousArrow from '../../assets/img/leftArrow.jpg';

const InnerContainer = styled(BodyContainer)`
  padding: 32px 0 50px;
  display: grid;
  grid-row-gap: 24px;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  z-index: 1;
  
  @media(min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-column-gap: 24px;
    align-items: center;
  }
  
  @media(min-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  
  @media(min-width: 1200px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`;

const Rope = styled.img`
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: -2%;
    z-index: 1;
`;

const SpiceBG = styled.img`
  display: none;
  
  @media(min-width: 768px) {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 65%;
  }
  
  @media(min-width: 1200px) {
    height: 80%
  }
  
  @media(min-width: 1680px) {
    height: auto;
  }
`;

const AffiliationImg = styled.img`
  width: 100%;
`;

const SliderContainer = styled.div`
  padding: 0 20px;
  
  @media(min-width: 992px) {
    padding: 0;
    
    .slick-slider{
        .slick-arrow{
            display:none !important;
        }
        .slick-prev {
          left: 0 !important;
        }
        .slick-next {
          right: 0 !important;
        }
        &:hover{
            .slick-arrow{
                display:block !important;
            }
        }
    }
  }
`;

const CarouselContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const CarouselImg = styled.img`
  cursor: pointer;
  height: 64px !important;
  
  @media(min-width: 768px) {
    height: initial !important;
  }
   
`;

const AffiliationsCard = styled(CardButton)`
  background: transparent;
`;

export const LeftArrow = (props) => {
    const {className, style, onClick} = props;
    return (
      <img
        className={className}
        onClick={onClick}
        style={{...style, height: 'auto', zIndex: '10'}}
        src={previousArrow}
        alt="previous arrow"/>
    )
}
export const RightArrow = (props) => {
    const {className, style, onClick} = props;
    return (
      <img
        className={className}
        onClick={onClick}
        style={{...style, height: 'auto', zIndex: '10'}}
        src={nextArrow}
        alt="next arrow"/>
    )
}

const Affiliations = (props) => {
    const settings = {
        dots: false,
        nextArrow: <RightArrow/>,
        prevArrow: <LeftArrow/>,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1680,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }]
    };
    const {data: {header, paragraph}, affiliateData} = props;
    return (
      <BodyContainer>
          <Rope src={ropeImg} alt="rope"/>
          <SpiceBG src={spiceImg} alt="spice"/>
          <InnerContainer>
              <AffiliationImg src={cardImg} alt="H & N Group Seafood Supplier"/>
              <AffiliationsCard
                header={header}
                subtitle={paragraph}
                buttonText="Discover"
                link="/affiliations"
                title="H & N Group Affilates"
              />

          </InnerContainer>
          <SliderContainer>
              <Slider {...settings} >
                  {affiliateData.map(i => {
                      const {name, link, logo} = i.node.acf;
                      return (
                        <a
                          key={name}
                          href={`https://${link}`}
                          target="_blank"
                        >
                            <CarouselContainer>
                                <CarouselImg src={logo.source_url} alt={logo.alt_text}/>
                            </CarouselContainer>
                        </a>
                      )
                  })}
              </Slider>
          </SliderContainer>
      </BodyContainer>

    );
};

export default Affiliations;



// WEBPACK FOOTER //
// ./src/components/Home/Affiliations.js